import React from 'react';
import cx from 'classnames';
import { MotorwayLogoShorthandIcon } from '@THC/components/Icons/MotorwayLogoShorthand';
import { MotorwayLogoWordmarkIcon } from '@THC/components/Icons/MotorwayLogoWordmark';
import { filterDataProps } from '@THC/utils/helpers';
import { VisuallyHidden } from '../__primitives__/VisuallyHidden';
import styles from './Logo.module.scss';
export const Logo = ({ shorthand, size = 'large', ...rest }) => (<div className={cx(styles.logo, styles[`${size}-${shorthand ? 'shorthand' : 'wordmark'}`])} {...filterDataProps(rest)}>
		{shorthand ? <MotorwayLogoShorthandIcon /> : <MotorwayLogoWordmarkIcon />}
		<VisuallyHidden>Motorway</VisuallyHidden>
	</div>);
